import React from 'react'
import { HelpModal } from '../../help/help-modal.component'

export const TapSemestersHelp = ({modalRef}) =>
  <HelpModal innerRef={modalRef} title='Why number of semesters of TAP matters'>
    It will determine the grades, credits etc. you'll need to meet to keep receiving TAP and also, how many semesters of
    TAP payments you have left.
  </HelpModal>